import { render, staticRenderFns } from "./FlightList.vue?vue&type=template&id=f222360c&"
import script from "./FlightList.vue?vue&type=script&lang=js&"
export * from "./FlightList.vue?vue&type=script&lang=js&"
import style0 from "./FlightList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports